var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#717171;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo_10_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,17.2c-3.8-3.8-8.8-5.9-14.1-5.9c-11,0-20,9-20,20c0,3.5,0.9,7,2.7,10l-2.8,10.4l10.6-2.8 c2.9,1.6,6.2,2.4,9.5,2.4h0c0,0,0,0,0,0c11,0,20-9,20-20C53,26,50.9,21,47.2,17.2z M33,48L33,48c-3,0-5.9-0.8-8.5-2.3L24,45.3 l-6.3,1.6l1.7-6.1l-0.4-0.6c-1.7-2.6-2.5-5.7-2.5-8.8c0-9.2,7.5-16.6,16.6-16.6c4.4,0,8.6,1.7,11.7,4.9 c3.1,3.1,4.9,7.3,4.9,11.7C49.6,40.5,42.2,48,33,48z M42.1,35.5c-0.5-0.2-3-1.5-3.4-1.6c-0.5-0.2-0.8-0.2-1.1,0.2 c-0.3,0.5-1.3,1.6-1.6,2c-0.3,0.3-0.6,0.4-1.1,0.1c-0.5-0.2-2.1-0.8-4-2.5c-1.5-1.3-2.5-3-2.8-3.5s0-0.8,0.2-1 c0.2-0.2,0.5-0.6,0.7-0.9c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.3,0.1-0.6,0-0.9C29.4,26.5,28.4,24,28,23c-0.4-1-0.8-0.8-1.1-0.9 c-0.3,0-0.6,0-1,0c-0.3,0-0.9,0.1-1.3,0.6c-0.5,0.5-1.7,1.7-1.7,4.2c0,2.5,1.8,4.8,2,5.2c0.2,0.3,3.5,5.4,8.5,7.5 c1.2,0.5,2.1,0.8,2.8,1.1c1.2,0.4,2.3,0.3,3.1,0.2c1-0.1,3-1.2,3.4-2.4c0.4-1.2,0.4-2.2,0.3-2.4C43,35.9,42.6,35.8,42.1,35.5z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7ba18a5f7b4ac1511a036086c34646ac.svg";
export { ForwardRef as ReactComponent };